export default {
    LANGUAGE_CHANGE_START: 'LANGUAGE_CHANGE_START'
};
